
export const environment = {
  production: false,
  endpointConsultaObligaciones: 'https://2ncqe7ikzh.execute-api.us-east-1.amazonaws.com/stage/',
  apiKeyConsultaObligaciones: 'BLX4v9u8SZ5ypiyL9ZPpV8qWPAWppXP73qvXq61l',
  stage: undefined,
  secretKey: 'lJ3pNfDe544KpkSkOThFhH35lyiUKM',
}
